import { useState } from "react";
import { trackEvents } from "@/mocks/baoliaoData";

export default function EventTrack() {
  const [expanded, setExpanded] = useState<string | null>(null);
  return (
    <section id="track" className="py-10 md:py-16 bg-foreground-950 text-background-100">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mb-8 md:mb-10">
          <span className="inline-flex items-center gap-1.5 text-primary-400 text-xs font-semibold tracking-wider uppercase">
            <i className="ri-radar-line"></i>
            热点追踪
          </span>
          <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-background-50 mt-2 tracking-tight">
            正在发酵的大事件
          </h2>
          <p className="text-sm text-background-100/70 mt-2 leading-relaxed">
            对高关注度事件做进度化梳理，从发生、发酵到各方回应，帮你一屏看清来龙去脉，不再被碎片信息带着走。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {trackEvents.map((ev) => {
            const isOpen = expanded === ev.id;
            const shownStages = isOpen ? ev.stages : ev.stages.slice(0, 3);
            return (
              <article
                key={ev.id}
                className="group flex flex-col rounded-2xl overflow-hidden border border-background-100/10 bg-background-100/5 hover:border-primary-400/30 transition-colors"
              >
                <div className="relative aspect-[5/3] overflow-hidden">
                  <img
                    src={ev.image}
                    alt={`${ev.title} 事件追踪配图`}
                    title={`${ev.title} · ${ev.cat}`}
                    className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 to-transparent"></div>
                  <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 rounded-full bg-primary-500 text-background-50 px-2.5 py-1 text-[11px] font-semibold">
                    <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-live"></span>
                    {ev.status}
                  </span>
                  <span className="absolute bottom-3 left-3 text-[11px] text-background-100/80">{ev.cat}</span>
                </div>
                <div className="flex flex-col flex-1 p-4 md:p-5">
                  <h3 className="font-heading font-bold text-base md:text-lg leading-snug text-background-50">
                    {ev.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-[13px] leading-relaxed text-background-100/65">{ev.desc}</p>

                  <div className="relative mt-4 pl-0">
                    {shownStages.map((st, i) => (
                      <div key={i} className="relative pl-5 pb-3 last:pb-0">
                        {i < shownStages.length - 1 && (
                          <span className="absolute left-[5px] top-4 bottom-0 w-px bg-background-100/15"></span>
                        )}
                        <span
                          className={`absolute left-0 top-1.5 w-[11px] h-[11px] rounded-full border-2 ${
                            i === shownStages.length - 1
                              ? "bg-primary-500 border-foreground-950 ring-2 ring-primary-500/40"
                              : "bg-background-100/40 border-foreground-950"
                          }`}
                        ></span>
                        <span className="block text-[10px] font-semibold text-accent-300">{st.time}</span>
                        <span className="block text-xs md:text-[13px] text-background-100/85 mt-0.5 leading-relaxed">
                          {st.text}
                        </span>
                      </div>
                    ))}
                  </div>

                  <button
                    onClick={() => setExpanded(isOpen ? null : ev.id)}
                    className="mt-auto pt-4 inline-flex items-center gap-1.5 text-xs font-semibold text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap"
                  >
                    <i className={`ri-${isOpen ? "subtract" : "add"}-line`}></i>
                    {isOpen ? "收起进度" : "展开完整时间线"}
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}